<template>
  <div class="error__wrapper">
    Such page does not exist
  </div>
</template>

<script>
export default {
  name: 'ErrorPage',
  layout: 'empty'
}
</script>

<style lang="scss" scoped></style>
